import * as React from 'react';

import DelegatePageHero from 'pages/delegate/components/DelegatePageHero/DelegatePageHero';
import DelegatesLoading from 'pages/delegate/components/DelegatesList/DelegatesLoading';

import { DEFAULT_OPTIONS, Tabs } from './DelegateMain.constants';
import { Main, SelectStyled, Title, ToggleGroupStyled, Wrapper } from './DelegateMain.styled';

const DelegatePageLoading = () => (
    <Main>
        <DelegatePageHero />
        <Wrapper>
            <Title>Delegates</Title>
            <ToggleGroupStyled
                value={Tabs.whitelist}
                options={DEFAULT_OPTIONS}
                onChange={() => {}}
                disabled
            />
            <SelectStyled
                value={Tabs.whitelist}
                options={DEFAULT_OPTIONS}
                onChange={() => {}}
                disabled
            />
            <DelegatesLoading />
        </Wrapper>
    </Main>
);

export default DelegatePageLoading;
